(function($) {
  $.fn.percentField = function () {
    var $this = $(this);
    var decimals = parseInt($this.data('decimals') || '0');
    $(this).autoNumeric('init', { aSign: '%', pSign: 's', vMin: '-999999999.99', mDec: decimals });
  };
})(jQuery);
